import React, {useEffect, useRef, useState} from 'react';

// Fades content up once when it enters the viewport.
// Motion itself lives in CSS (.cpr-reveal) and is disabled under prefers-reduced-motion.
function Reveal({as: Tag = 'div', delay = 0, className = '', style, children, ...rest}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node || typeof IntersectionObserver === 'undefined') {
            setVisible(true);
            return undefined;
        }
        const observer = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) {
                setVisible(true);
                observer.disconnect();
            }
        }, {rootMargin: '0px 0px -10% 0px', threshold: 0.1});
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <Tag ref={ref}
             className={`cpr-reveal${visible ? ' is-visible' : ''}${className ? ' ' + className : ''}`}
             style={delay ? {...style, '--cpr-reveal-delay': `${delay}ms`} : style}
             {...rest}>
            {children}
        </Tag>
    );
}

export default Reveal;
